import React from "react";
import { GripVertical } from "lucide-react";

/**
 * Einheitlicher Desktop-Drag-Handle (wie zuvor im RoadmapModal): GripVertical, slate-Rahmen.
 * Auf Mobile nicht rendern — dort bleibt das Verschieben aus.
 */
export default function ModalDragHandle({
  onMouseDown,
  title = "Move",
  ariaLabel = "Move modal",
  className = "",
}) {
  return (
    <button
      type="button"
      className={`drag-handle inline-flex h-9 w-9 shrink-0 cursor-move items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-400 transition hover:bg-slate-50 hover:text-slate-600 ${className}`.trim()}
      title={title}
      aria-label={ariaLabel}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onMouseDown?.(e);
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <GripVertical className="h-4 w-4" />
    </button>
  );
}
